import commitMutation from 'relay-commit-mutation-promise';
import { graphql } from 'react-relay/legacy';

const mutation = graphql`
    mutation holdRequestMutation($input: CreateHoldRequestInput!, $userId: String!) {
        createHoldRequest(input: $input) {
            item {
                isOnHold
                hasRequestedHoldForBuyer(buyerId: $userId)
                relevantHoldForBuyer(buyerId: $userId) {
                    isRequested
                }
            }
        }
    }
`;

export function holdRequestMutation(environment, args) {
    const { itemId, userId, sellerId, vertical, duration } = args;

    const input = {
        itemId,
        userId,
        sellerId,
        vertical,
        duration,
    };

    return commitMutation(environment, {
        mutation,
        variables: { input, userId },
    });
}
